export default __webpack_public_path__ + "static/media/allerta.e2048e35.woff2";